import React, { useState } from 'react';
import {
  useStripe,
  useElements,
  PaymentElement,
} from '@stripe/react-stripe-js';
import { Button, Box, Alert } from '@chakra-ui/react';

const PaymentForm = ({ onSuccess, onError }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePaymentSubmit = async () => {
    if (!stripe || !elements || isProcessing) return;

    setIsProcessing(true);
    setMessage('');

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: `${window.location.origin}/payment-result`,
        },
        redirect: 'if_required',
      });

      if (error) {
        setMessage(error.message);
        if (onError) {
          onError(error);
        }
        setIsProcessing(false);
        return;
      }

      if (
        paymentIntent &&
        (paymentIntent.status === 'succeeded' ||
          paymentIntent.status === 'processing')
      ) {
        await Promise.resolve(
          onSuccess?.({
            status: paymentIntent.status,
            paymentMethodId: paymentIntent.payment_method,
            paymentIntentId: paymentIntent.id,
            paymentStatus: paymentIntent.status,
            paymentMethod: 'elettronico',
          })
        );
        return;
      }

      setIsProcessing(false);
    } catch (err) {
      setMessage(err?.message || 'Errore durante il pagamento.');
      if (onError) {
        onError(err);
      }
      setIsProcessing(false);
    }
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={4}
      mt={4}
      width="100%"
      max-width="540px"
      margin="0 auto"
    >
      {/* This is the full payment form from Stripe */}
      <PaymentElement id="payment-element" />

      {message && (
        <Alert status="error" mt={4}>
          C&apos;è stato un errore. {message}
        </Alert>
      )}

      <Button
        mt={4}
        width="100%"
        colorScheme="blue"
        onClick={handlePaymentSubmit}
        isLoading={isProcessing}
        loadingText="Pagamento in corso..."
        isDisabled={!stripe || !elements || isProcessing}
      >
        Paga ora
      </Button>
    </Box>
  );
};

export default PaymentForm;
